import React from 'react';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { Alert } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as SuccessIcon } from "./assets/icons/successIcon.svg";
import { withTranslate } from '../../../core/TenantProvider';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#ffffff',
      margin: "0 auto 20px",
      boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
      "& .MuiCollapse-wrapperInner": {
        display: 'flex',
        justifyContent: 'center',
        "& .MuiAlert-outlinedSuccess": {
          border: "none",
          "& .MuiAlert-icon": {
            margin: "6px 6px 0 0",
          },
          "& .MuiAlert-action": {
            margin: 0,
          },
          "& .MuiAlert-message": {
            fontSize: "16px",
            padding: "13px 0",
            color: "#4A4A4A",
          },
          "& .MuiSvgIcon-fontSizeInherit": {
            fontSize: "20px"
          },
        },
      },
    },
    boldFont: {
    },
    copy: {
    }
  })
);

const SuccessMessage = (props: any) => {
  const {translate, successMessage} = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState<boolean>(true);

  return (
    <div className={classes.root}>
      <Collapse in={open}>
        <Alert
          role="alert"
          iconMapping={{ success: <SuccessIcon fontSize="inherit" /> }}
          variant="outlined"
          severity="success"
          action={
            <IconButton
              data-testid='successmsg'
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <strong className={classes.boldFont}>{translate('notifications.heading.success')} &nbsp;</strong>
          <span className={classes.copy}>{successMessage}</span>
        </Alert>
      </Collapse>
    </div>
  );
}

export default withTranslate(
  (SuccessMessage)
);